import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";

import {
  clearDataFile,
  postDataFile,
} from "../../../../../utils/data/dataActions";
import { POST_DATA_FILE_FAILURE } from "../../../../../utils/data/dataActionTypes";
import { CLIENTS } from "../../../../../utils/data/models";

import * as downloaderActions from "../../../../../utils/downloader/downloaderActions";
import MessageBox from "../../../../common/MessageBox";
import englishTranslations from "../../../../../components/intl/en-CA";
import frenchTranslations from "../../../../../components/intl/fr-CA";
import { toast } from "react-toastify";
import { canDownload } from "../../../../common/CanDownload";
import { downloaderEnums } from "../../../../../utils/downloader/downloaderEnums";
import { TERMINATED } from "../../enums/clientStatusTypes";
import userHasAccess from "../../../../../utils/userHasAccess";
import { FINTECH } from "../../../../../utils/Roles";

class ExportSalaries extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      exporting: false,
      remoteErrorCode: "",
      downloadPath: null,
    };

    this.downloadComplete = this.downloadComplete.bind(this);
    this.exportSalaries = this.exportSalaries.bind(this);
  }

  componentDidUpdate() {
    if (this.state.downloadPath) {
      if (this.props.successDownloads.length > 0) {
        let finishedDownloadObj = this.props.successDownloads.find(
          (download) => download.path == this.state.downloadPath
        );

        if (finishedDownloadObj) {
          this.setState({ downloadPath: null });
          this.downloadComplete();
        }
      }
      if (this.props.errorDownloads.length > 0) {
        let finishedDownloadObj = this.props.errorDownloads.find(
          (download) => download.path == this.state.downloadPath
        );

        if (finishedDownloadObj) {
          this.setState({ downloadPath: null });
          this.downloadComplete();
        }
      }
    }
  }

  buildDescription(clientName) {
    const userLanguage = localStorage.getItem("languageCode") || "en-CA";

    if(userLanguage == "fr-CA"){
      return frenchTranslations.downloader.clientSalaryExport + ": " + clientName;
    }

    return englishTranslations.downloader.clientSalaryExport + ": " + clientName;
  }

  downloadComplete() {
    this.setState({ exporting: false });
    this.props.clearDataFile(CLIENTS);
  }

  exportSalaries(event) {
    event.preventDefault();
    const {
      authLanguageCode,
      client: { clientId },
      postDataFile,
    } = this.props;
    this.setState({
      exporting: true,
      remoteErrorCode: "",
    });

    const path = `${clientId}/export-salaries?filters=clients.clientId==${clientId}`;
    const body = { createCookie: true };
    const headers = { "Accept-Language": authLanguageCode };
    const description = this.buildDescription(this.props.client.name);

    return postDataFile(CLIENTS, path, body, headers).then((data) => {
      if (data.type === POST_DATA_FILE_FAILURE) {
        this.setState({
          exporting: false,
          remoteErrorCode: data.payload.error.data.message.error,
        });
      } else {
        if (canDownload(description, this.props.currentDownloads)) {
          this.setState({ downloadPath: this.props.shortLivedURL });
          this.props.downloaderActions.downloadFile(
            this.props.shortLivedURL,
            description
          );
        } else {
          toast(
            <FormattedMessage
              id="downloader.duplicateDownload"
              values={{ file: description, br: <br /> }}
            />,
            {
              type: toast.TYPE.ERROR,
              autoClose: downloaderEnums.AUTO_CLOSE,
            }
          );
          this.setState({ exporting: false });
        }
      }
    });
  }

  renderRemoteErrorMessage() {
    const { remoteErrorCode } = this.state;
    return (
      <MessageBox className="alert-danger">
        <div>
          <p>
            <FormattedMessage
              id={`validation.customMessages.${remoteErrorCode}`}
            />
          </p>
        </div>
      </MessageBox>
    );
  }

  render() {
    const { exporting, remoteErrorCode } = this.state;
    const { client } = this.props;

    const isClientTerminated = client && client.clientStatusType === TERMINATED.value && !userHasAccess(FINTECH);

    return (
      <div className="import-export export-salaries">
        <form onSubmit={this.exportSalaries} className="export-salaries-form">
          <h3>
            <FormattedMessage id="bulkSalaries.exportSalaries.title" />
          </h3>
          {remoteErrorCode && this.renderRemoteErrorMessage()}
          <div className="import-export-submit">
            <span className="import-export-button">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={exporting || this.props.isArchived || isClientTerminated}
              >
                <FormattedMessage id="bulkSalaries.exportSalaries.form.button" />
              </button>
            </span>
            {exporting && (
              <span className="import-export-loader">
                <span className="loader">
                  <FormattedMessage id="bulkSalaries.exportSalaries.form.exporting" />
                </span>
              </span>
            )}
          </div>
        </form>
      </div>
    );
  }
}

ExportSalaries.propTypes = {
  authLanguageCode: PropTypes.string,
  clearDataFile: PropTypes.func,
  client: PropTypes.object,
  cookieName: PropTypes.string,
  postDataFile: PropTypes.func,
  shortLivedURL: PropTypes.string,
  isArchived: PropTypes.bool,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  currentDownloads: PropTypes.array,
  downloaderActions: PropTypes.object,
};

function mapStateToProps(state) {
  const clients = state.data.clients || {};
  const file = clients.shortLivedURL || {};
  const downloads = state.downloader || {};
  const client = clients.active || {};
  
  return {
    authLanguageCode: state.auth.user.languageCode,
    client: client || {},
    cookieName: file.cookieName || null,
    shortLivedURL: file.fileUrl || null,
    currentDownloads: downloads.files || [],
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
    isArchived: client ? client.isArchived : false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearDataFile: bindActionCreators(clearDataFile, dispatch),
    postDataFile: bindActionCreators(postDataFile, dispatch),
    downloaderActions: bindActionCreators(downloaderActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExportSalaries);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/bulkSalaries/ExportSalaries.js